/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type Bdkv2BinaryOperator =
  (typeof Bdkv2BinaryOperator)[keyof typeof Bdkv2BinaryOperator];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Bdkv2BinaryOperator = {
  BinaryOperatorAnd: 'BinaryOperatorAnd',
  BinaryOperatorOr: 'BinaryOperatorOr',
  BinaryOperatorEquals: 'BinaryOperatorEquals',
  BinaryOperatorNotEquals: 'BinaryOperatorNotEquals',
  BinaryOperatorIn: 'BinaryOperatorIn',
  BinaryOperatorHas: 'BinaryOperatorHas',
  BinaryOperatorLessThan: 'BinaryOperatorLessThan',
  BinaryOperatorGreaterThan: 'BinaryOperatorGreaterThan',
  BinaryOperatorLessThanOrEqual: 'BinaryOperatorLessThanOrEqual',
  BinaryOperatorGreaterThanOrEqual: 'BinaryOperatorGreaterThanOrEqual',
} as const;
